var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrance(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M47.956,65.417c-4.209,0-7.633,3.424-7.633,7.633c0,1.104,0.896,2,2,2s2-0.896,2-2c0-2.003,1.63-3.633,3.633-3.633 s3.633,1.63,3.633,3.633c0,1.104,0.896,2,2,2s2-0.896,2-2C55.589,68.841,52.165,65.417,47.956,65.417z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.102,71.895l-6.652-9.403c0.256-0.336,0.407-0.755,0.407-1.21c0-1.104-0.896-2-2-2h-0.411l-1.596-3.84 c0.455-0.366,0.746-0.928,0.746-1.558c0-1.074-0.847-1.95-1.908-1.998l-5.68-29.316c-0.188-0.972-1.062-1.621-2.008-1.62 c-0.932,0-1.819,0.648-2.007,1.62l-5.68,29.314c-1.103,0.002-1.997,0.896-1.997,2c0,0.66,0.32,1.245,0.813,1.609l-1.574,3.788h-0.5 c-1.104,0-2,0.896-2,2c0,0.481,0.17,0.924,0.454,1.269l-6.611,9.345c-0.638,0.901-0.424,2.15,0.478,2.788 c0.903,0.639,2.151,0.424,2.788-0.478l7.729-10.924h16.216l7.728,10.924c0.39,0.551,1.008,0.845,1.635,0.845 c0.399,0,0.803-0.119,1.153-0.367C67.525,74.045,67.739,72.797,67.102,71.895z M48,33.238l3.612,18.646h-7.225L48,33.238z  M41.887,59.281l1.411-3.397h9.404l1.411,3.397H41.887z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrance);
export default __webpack_public_path__ + "static/media/france.07d539e2d77f3f2f747f16af4a9eced5.svg";
export { ForwardRef as ReactComponent };